import { useEffect } from 'react';

import MarketTrend from '../MarketTrend';

import { Helmet } from "react-helmet";

const MarketTrendTW = () => {
	useEffect(() => {
		let pageLastViewed = localStorage.getItem("page-last-viewed");
		pageLastViewed = JSON.parse(pageLastViewed);
		pageLastViewed.markettrend.tw = new Date().getTime();
		localStorage.setItem("page-last-viewed", JSON.stringify(pageLastViewed));
	}, [ ]);

	return (
		<>
			<Helmet>
				<title>Market Trend (TW) - Finetic App</title>
			</Helmet>
			<MarketTrend exchange="TW" />
		</>
	);
};

export default MarketTrendTW;
